import React, { useEffect, useState } from "react";
import { useSSA } from "../SSAContext";
import { Card } from "../ui";
import { RequestTable } from "./BuyerRequestsPage";

export default function WorkbenchPage() {
  const { call, refreshKey } = useSSA();
  const [rows, setRows] = useState([]);
  useEffect(() => { call("get", "/requests?view=procurement", null, "procurement").then((d) => setRows(d.requests)).catch(() => {}); }, [call, refreshKey]);
  const count = (fn) => rows.filter(fn).length;
  const kpis = [
    ["Awaiting review", count((r) => r.status === "submitted")],
    ["RFQs open", count((r) => ["rfq_issued", "partner_clarification"].includes(r.status))],
    ["To evaluate", count((r) => ["responses_received", "evaluation", "shortlisted"].includes(r.status))],
    ["With buyer", count((r) => ["quote_issued", "buyer_clarification", "buyer_accepted"].includes(r.status))],
    ["PO chain done", count((r) => r.status === "infosys_po_issued")],
  ];
  return (
    <div data-testid="workbench-page">
      <h1 className="font-display text-3xl font-semibold text-slate-900">Infosys Procurement Workbench</h1>
      <p className="text-sm text-slate-500 mt-1 mb-6">Intake validation, routing, proposal comparison, fee, buyer quote, buyer PO and supplier PO — AI advises, procurement decides.</p>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-5">
        {kpis.map(([k, v]) => (
          <div key={k} className="bg-white rounded-xl border border-slate-200 p-4" data-testid={`wb-kpi-${k.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">{k}</div>
            <div className="font-display text-3xl font-semibold text-[#0B2A4A]">{v}</div>
          </div>
        ))}
      </div>
      <Card title="Request queue"><RequestTable rows={rows} linkBase="/services/workbench" testid="workbench-queue-table" /></Card>
    </div>
  );
}
